export const UPDATE_USER_REQUEST = 'USER_UPDATE_REQUEST';
export const UPDATE_USER_SUCCESS = 'USER_UPDATE_SUCCESS';
export const UPDATE_USER_FAILURE = 'USER_UPDATE_FAILURE';



// WEBPACK FOOTER //
// ./src/constants/user.js